import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-4 grid-1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = { class: "flex space-x-3 justify-end" }

import BaseModal from '@components/modals/BaseModal.vue';
import { computed, ref } from 'vue';
import * as Joi from 'joi';
import { useValidator } from '@/libs/validator';
import SwitchSection from '@ui-kit/inputs/switch/SwitchSection.vue';
import Label from '@ui-kit/label/Label.vue';
import ValidationKeyObserver from '@components/validation/ValidationKeyObserver.vue';
import SingleLine from '@ui-kit/inputs/single-line/SingleLine.vue';
import Button from '@ui-kit/controls/button/Button.vue';
import { useI18n } from 'vue-i18n';
import { useModalControls } from '@components/modals';

interface Emits {
  (e: 'save', value: number): void;
}
interface Props {
  value: number;
}
interface FormData {
  value: string;
  discount: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalManageAdjustment',
  props: {
    value: null
  },
  emits: ["save"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'save', value: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: number;
}

const { t } = useI18n();
const { close } = useModalControls();

const rules = Joi.object({
  discount: Joi.boolean(),
  value: Joi.number().allow('', null).min(0).when('discount', {
    is: Joi.valid(true),
    then: Joi.number().max(100),
  }),
});





const formData = ref<FormData>({
  discount: Math.sign(props.value) === -1,
  value: String(props.value ? Math.abs(props.value) || '' : ''),
});

const validator = useValidator({
  data: formData,
  schema: computed(() => rules),
});

const types = [
  {
    id: 1,
    name: t('pages.orders.discount'),
  },
  {
    id: 2,
    name: t('pages.orders.markup'),
  },
];

function save() {
  if (validator.validate()){
    const sign = formData.value.discount ? -1 : 1;
    emit('save', sign * Number(formData.value.value));
    close();
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    size: "md",
    "no-body-padding": "",
    title: _ctx.$t('pages.orders.adjustment')
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SwitchSection, {
          options: types,
          "model-value": formData.value.discount ? 1 : 2,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (formData.value.discount = $event === 1))
        }, null, 8, ["model-value"]),
        _createVNode(Label, {
          label: _ctx.$t('fields.value') + ' (%)'
        }, {
          default: _withCtx(({id}) => [
            _createVNode(ValidationKeyObserver, { keys: "value" }, {
              default: _withCtx(({firstErrorMessage}) => [
                _createVNode(SingleLine, {
                  modelValue: formData.value.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.value) = $event)),
                  errors: firstErrorMessage,
                  type: "number",
                  id: id
                }, null, 8, ["modelValue", "errors", "id"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["label"]),
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(Button, {
            onClick: _unref(close),
            "button-type": "outline"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.actions.cancel')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(Button, { onClick: save }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.actions.save')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})